angular.module('app.filters').filter('boolean', () =>
    function(b, trueText, falseText) {
        if (b == null) { return ''; }
        if (b) {
            return trueText || 'Yes';
        } else {
            return falseText || 'No';
        }
    }
);


// WEBPACK FOOTER //
// ./filters/boolean.js